module.exports = __webpack_public_path__ + "img/aisla-forte.db9d4af9.svg";